import { Action } from "../actions/actionsShared"
import {
  FETCH_INSIGHT_CACHE_PREFIX,
  FETCH_INSIGHT_IMAGE_BEGIN,
  FETCH_INSIGHT_IMAGE_FAILURE,
  FETCH_INSIGHT_IMAGE_SUCCESS,
  FETCH_USER_INSIGHTS_BEGIN,
  FETCH_USER_INSIGHTS_FAILURE,
  FETCH_USER_INSIGHTS_GRAPH_BEGIN,
  FETCH_USER_INSIGHTS_GRAPH_FAILURE,
  FETCH_USER_INSIGHTS_GRAPH_SUCCESS,
  FETCH_USER_INSIGHTS_SUCCESS,
  UPDATE_USER_CONFIRM_BEGIN,
  UPDATE_USER_CONFIRM_FAILURE,
  UPDATE_USER_CONFIRM_SUCCESS,
} from "../actions/userInsightsActions"
import { getImageKey } from "../util/photo"

const initialState = {
  userInsightsData: [],
  userNotificationsData: [],
  userInsightsGraphData: {},
  userInsightInfoLoading: false,
  insightImages: {},
  result: "",
  userInsightCache: {},
  lastInsightFetch: Date.now(),
}

const userInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_INSIGHTS_BEGIN:
      return {
        ...state,
        userInsightInfoLoading: true,
        result: "BEGINNING",
      }
    case FETCH_USER_INSIGHTS_SUCCESS: {
      const photosMap = action.payload.photosMap
      return {
        ...state,
        lastInsightFetch: Date.now(),
        userInsightsData: action.payload.insights.map((insight) => {
          const photoKey = `${insight.insight_id}_${insight.device_id}_${insight.table}`
          return {
            device_id: insight.device_id,
            device_name: insight.device_name,
            display_name: insight.display_name,
            confidence: insight.confidence,
            time_stamp: insight.time_stamp,
            file_ctime: insight.file_ctime,
            photoUrl: photoKey in photosMap ? photosMap[photoKey]?.path : null,
            photoCreatedAt: photoKey in photosMap ? photosMap[photoKey]?.createdAt : null,
            is_from_lora: insight.is_from_lora,
            group_confidence: insight.group_confidence,
            userConfirmed: insight.userConfirmed,
            insight_id: insight.insight_id,
            latitude: insight.lat,
            longitude: insight.long,
            comms_source: insight.comms_source,
            class_name: insight.class_name,
            class_id: insight.class_id,
            alg_id: insight.alg_id,
            table: insight.table,
            insight_status: insight.insightStatus,
            collection_id: insight.collection_id,
            window_start: insight.window_start,
            window_end: insight.window_end,
            collection: !!insight.collection_id,
            class_list: insight.class_list,
            message_id: insight.device_message_identifier,
            message_index: insight.device_message_index,
            insights: insight.insights
              ? insight.insights.map((i) => {
                  const photoKeyLocal = `${i.insight_id}_${i.device_id}_${i.table}`
                  return {
                    ...i,
                    photoUrl: photoKeyLocal in photosMap ? photosMap[photoKeyLocal]?.path : null,
                  }
                })
              : null,
          }
        }),
        userInsightInfoLoading: false,
        result: "SUCCESS",
      }
    }
    case FETCH_USER_INSIGHTS_FAILURE:
      return {
        ...state,
        result: "FAILURE",
        userInsightInfoLoading: false,
      }
    case FETCH_USER_INSIGHTS_GRAPH_BEGIN:
      return {
        ...state,
        result: "BEGINNING",
      }
    case FETCH_USER_INSIGHTS_GRAPH_SUCCESS:
      return {
        ...state,
        userInsightsGraphData: action.payload.response.data.message,
        result: "SUCCESS",
      }
    case FETCH_USER_INSIGHTS_GRAPH_FAILURE:
      return {
        ...state,
        result: "FAILURE",
      }
    case UPDATE_USER_CONFIRM_BEGIN:
      return {
        ...state,
        result: "BEGINNING",
      }
    case UPDATE_USER_CONFIRM_SUCCESS:
      return {
        ...state,
        result: "SUCCESS",
      }
    case UPDATE_USER_CONFIRM_FAILURE:
      return {
        ...state,
        result: "FAILURE",
      }

    case FETCH_INSIGHT_IMAGE_BEGIN:
      return {
        ...state,
        result: "BEGINNING",
      }
    case FETCH_INSIGHT_IMAGE_SUCCESS: {
      const payload = action.payload
      const imageKey = getImageKey(
        payload.deviceId,
        payload.insightId,
        payload.algId,
        payload.className,
        payload.table,
      )
      const dataBuffer = payload.dataBuffer
      if (!state.insightImages[imageKey]) {
        state.insightImages[imageKey] = {}
      }
      return {
        ...state,
        insightImages: {
          ...state.insightImages,
          [imageKey]: {
            ...state.insightImages[imageKey],
            dataBuffer,
          },
        },
        result: "SUCCESS",
      }
    }
    case FETCH_INSIGHT_IMAGE_FAILURE:
      return {
        ...state,
        result: "FAILURE",
      }
    case `${FETCH_INSIGHT_CACHE_PREFIX}${Action.BEGIN_SUFFIX}`:
      return {
        ...state,
        result: "BEGINNING",
      }
    case `${FETCH_INSIGHT_CACHE_PREFIX}${Action.SUCCESS_SUFFIX}`:
      return {
        ...state,
        userInsightCache: action.payload.data.data.message,
        result: "SUCCESS",
      }
    case `${FETCH_INSIGHT_CACHE_PREFIX}${Action.FAILURE_SUFFIX}`:
      return {
        ...state,
        result: "FAILURE",
      }
    default:
      return state
  }
}

export default userInsightsReducer
